export default "__VITE_ASSET__BiFw8vey__"